import {
  Component,
  OnInit,
  OnChanges,
  Input,
  SimpleChanges,
  OnDestroy,
  ViewChild,
  AfterViewInit,
} from "@angular/core";
import {
  BenchmarkDataPrimaryLookupService,
  BmarkFixingData,
  BmarkFixingType,
} from "shared/cubiq-services";
import { BmarkClientOrdersBlotterMode } from "../../shared/cubiq-services/model/benchmarks/enums/BmarkClientOrdersBlotterMode.enum";
import { BmarkFixingsManagerService } from "./services/bmark-fixings-manager.service";
import { Subscription } from "rxjs";
import { BmarkClientOrdersBlotterComponent } from "./blotters/client-orders/bmark-client-orders-blotter.component";
import { ChildBlotterComponent } from "./models/bmark-sub-blotter.interface";
import { FilterConfiguration } from "../bfx-blotter-filter/FilterConfiguration";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Component({
  selector: "bmark-summary-client-orders",
  templateUrl: "./html/bmark-summary-client-orders.html",
  standalone: false,
})
export class BmarkSummaryClientOrdersComponent
  implements OnInit, OnChanges, OnDestroy, ChildBlotterComponent
{
  @Input() activeView: BmarkClientOrdersBlotterMode;

  /**********************************************************************/
  /* DATA */
  public orderIds: string = "";
  public tableView: string = "";
  public fixing: string = "";
  public type: string = "";

  private displayFixingSubscription: Subscription;

  @ViewChild(BmarkClientOrdersBlotterComponent, { static: true })
  bmarkClientOrdersBlotter: BmarkClientOrdersBlotterComponent;
  /**********************************************************************/
  /* CONSTRUCTOR */
  constructor(private bmarkManager: BmarkFixingsManagerService) {}

  /**********************************************************************/
  /* INITIALIZE */
  ngOnInit() {
    this.initializeManager();
  }

  protected initializeManager(): void {
    this.displayFixingSubscription = this.bmarkManager.displayFixing$.subscribe(
      (fixingData: BmarkFixingData) => {
        if (fixingData instanceof BmarkFixingData) {
          logger.out.info(
            `BMARK: UI-BLOTTER -> [${fixingData.id}] COMPLETE - UPDATE DISPLAY (${
              fixingData.hasClientOrders() ? fixingData.getClientOrderIds().length : 0
            })`,
          );
          this.type = `${BmarkFixingType[fixingData.type]}`;
          this.fixing = `${fixingData.displayTime} ${fixingData.code} (${fixingData.displayDate})`;
          this.orderIds = fixingData.hasClientOrders()
            ? fixingData.getClientOrderIds().toString()
            : "Unknown";
        } else {
          this.type = "";
          this.fixing = "";
          this.orderIds = "";
        }
      },
    );
  }

  /**********************************************************************/
  /* CHANGES */
  ngOnChanges(changes: SimpleChanges) {
    for (let propName in changes) {
      switch (propName) {
        case "activeView":
          this.tableView = BmarkClientOrdersBlotterMode[this.activeView];
          break;
      }
    }
  }
  /**********************************************************************/
  /* Destroy */
  ngOnDestroy() {
    if (this.displayFixingSubscription) {
      this.displayFixingSubscription.unsubscribe();
      this.displayFixingSubscription = null;
    }
  }

  /**********************************************************************/
  /* BLOTTER - Instance */

  public getBlotterInstance(): any {
    return this.bmarkClientOrdersBlotter.getBlotterInstance();
  }

  filterSelectionChanged(filterConfiguration: FilterConfiguration) {
    this.bmarkClientOrdersBlotter.filterAppliedEvent();
    this.bmarkClientOrdersBlotter.filterSelectionChanged(filterConfiguration);
  }

  getFilterConfiguration(): void {
    return this.bmarkClientOrdersBlotter.getFilterConfiguration();
  }

  setBlotterFilterComponent(blotterFilter: any): void {
    this.bmarkClientOrdersBlotter.setBlotterFilterComponent(blotterFilter);
  }

  refreshSelectionCells(): void {
    this.bmarkClientOrdersBlotter.refreshSelectionCells();
  }

  hasCellRenderedSelection(): boolean {
    return this.bmarkClientOrdersBlotter.hasCellRenderedSelection();
  }

  /**********************************************************************/
  /* BLOTTER - PROFILE */

  public getClientOrdersConfiguration(): any {
    return this.bmarkClientOrdersBlotter.getComponentConfiguration();
  }

  public getBlotterId(): string {
    return this.bmarkClientOrdersBlotter.getBlotterId();
  }

  public getProfileSettingKey(): string {
    return this.bmarkClientOrdersBlotter.getProfileSettingKey();
  }
}
